const heroCardSliderBlock = document.querySelectorAll<HTMLElement>('.block-hero-card-slider');
heroCardSliderBlock.forEach((block) => {
	const slider = block.querySelector<HTMLElement>('.block-hero-card-slider__slider');
	let iSlider = null;
	let iNavSlider = null;
	if (null !== slider) {
		iSlider = new (window as Window).Swiper(slider, {
			spaceBetween: 20,
			slidesPerView: 1,
			loop: true,
			speed: 1000,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		});
	}
	const navSlider = block.querySelector<HTMLElement>('.block-hero-card-slider__nav-slider');
	if (null !== navSlider) {
		iNavSlider = new (window as Window).Swiper(navSlider, {
			spaceBetween: 20,
			slidesPerView: 1,
			loop: true,
			effect: 'fade',
			speed: 1000,
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				enabled: true,
				nextEl: navSlider.querySelector(
					'.block-hero-card-slider-button-next'
				) as HTMLElement,
				prevEl: navSlider.querySelector(
					'.block-hero-card-slider-button-prev'
				) as HTMLElement,
			},
		});
	}
	if (iSlider && iNavSlider) {
		iSlider.controller.control = iNavSlider;
		iNavSlider.controller.control = iSlider;
	}
});
